export default __webpack_public_path__ + "static/media/survivorBg.a4f03199.png";